"use client";

import Skeleton from "@/components/atoms/Skeleton";
import { useLogoutShowroomUser } from "@/lib/showroom/hooks/useShowroom";
import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useTransition } from "react";

const Logout = ({
  redirect,
  reason
}: {
  redirect?: string;
  reason?: string;
}) => {
  const wipedRef = useRef(false);
  if (typeof window !== "undefined" && !wipedRef.current) {
    usePersistedStore.setState({ showroomToken: "" });
    wipedRef.current = true;
  }

  const { logout } = useLogoutShowroomUser();
  const router = useRouter();
  const queryClient = useQueryClient();

  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      logout();
      setTimeout(() => {
        const searchParams = new URLSearchParams();
        if (reason) searchParams.set("reason", reason);
        if (redirect)
          searchParams.set("redirect", encodeURIComponent(redirect));

        const path = searchParams.size
          ? `/forhandler?${searchParams.toString()}`
          : "/forhandler";

        console.log(path);
        router.push(path);
      }, 100);
    });
  }, [redirect, logout, router, reason]);

  return (
    <div data-layout="page" style={{ paddingTop: "1rem" }}>
      {isPending && <Skeleton height="30vh" />}
    </div>
  );
};

export default Logout;
